<template>
  <div class="intro-content">
    <button @click="startQuiz" type="button" class="getstart w-btn us-btn-style_1">
      <span class="w-btn-label">Get Started</span>
    </button>
  </div>
</template>

<script>

import { mapMutations } from "vuex";

export default {
  name: 'QuizIntro',
  methods: {
    ...mapMutations( ['setStartStatus'] ),

    startQuiz() {
      this.setStartStatus( true );
    },
  }
}
</script>